// extracted by mini-css-extract-plugin
var _1 = "_availableInventory-module__container";
var _2 = "_availableInventory-module__table-container";
var _3 = "_availableInventory-module__title";
var _4 = "_availableInventory-module__title-container";
export { _1 as "container", _2 as "table-container", _3 as "title", _4 as "title-container" }
